import { render } from "./ReportsClaims.vue?vue&type=template&id=585f6a4c&scoped=true"
import script from "./ReportsClaims.vue?vue&type=script&lang=js"
export * from "./ReportsClaims.vue?vue&type=script&lang=js"

import "./ReportsClaims.vue?vue&type=style&index=0&id=585f6a4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585f6a4c"]])

export default __exports__